/* !
 * jQuery support v1.0.0
 * Copyright 2018, Connecty Inc.
 */
(function($, THERMOS, cssua){

	// シリーズ情報JSON
	const getJSONseries = (_seriesID) => {
		const jsonURL = THERMOS.va.isEnglish ? `/ajax/english/product/spec/${_seriesID}.json` : `/ajax/product/spec/${_seriesID}.json`;
		return $.getJSON(jsonURL);
	};
	// シリーズ製品品番出力
	const setSeriesProd = () => {
		$('.rt_cf_pse_product_name').each((idx, item) => {
			$(item).html($(item).text().replace(/\//, '<br>'));
		});
	};
	// シリーズ製品「取扱説明書」を入れる
	const setSeriesManualText = () => {
		$('.rt_cf_ppt_pdf_file_name').each((idx, item) => {
			if (!$(item).find('.rt_cf_ppt_pdf_file_title').length) {
				$(item).find('i').after('<span>取扱説明書</span>');
			}
		});
	};
	// PDFサイズをバイト表記に変換
	const bytesToSize = () => {
		const $obj = $('.js-bytesToSize');
		const sizesArr = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

		if ($obj[0]) {
			$obj.each((idx, ele) => {
				let objText = $(ele).text();
				if (objText === 0) objText = 'n/a';

				let num = parseInt(Math.floor(Math.log(objText) / Math.log(1024)), 10);
				if (num === 0) objText = objText + ' ' + sizesArr[num];

				$(ele).text((objText / Math.pow(1024, num)).toFixed(1) + ' ' + sizesArr[num]);
			});
		}
	};

	setSeriesProd();
	setSeriesManualText();
	bytesToSize();

	// 品番検索フォーム： placeholder SP表示切り分け
	if (THERMOS.va.window.width < 768) {
		$('.js-searchManual').find('input[type="text"]').attr('placeholder', '品番を入力してください');
	}

})(window.jQuery, window.THERMOS, window.cssua);
